<template>
  <v-dialog v-model="show" hide-overlay persistent content 
    content-class="centered-loading-dialog" 
    style="box-shadow: none !important; -moz-box-shadow: none !important; -webkit-box-shadow: none !important; border-radius: 0px !important; -moz-border-radius: 0px !important; -webkit-border-radius: 0px !important; width: auto !important;">
    <v-container fill-height>
      <v-layout column justify-center align-center>
        <semipolar-spinner :animation-duration="2000" :size="65" color="#f8a135" />
        <h2 v-if="message != null">{{message}}</h2>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<style>
.centered-loading-dialog {
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  -webkit-border-radius: 0px !important;
  width: auto !important;
}
</style>

<script>
import {SemipolarSpinner} from 'epic-spinners'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    SemipolarSpinner
  },
  computed: {
    ...mapGetters('loading', ['show', 'message'])
  },
  methods: {
    ...mapMutations('loading', ['showLoading', 'hideLoading'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Loading.vue